// extracted by mini-css-extract-plugin
module.exports = {"chart":"NewCustomer_chart__1cKAm","legend":"NewCustomer_legend__1QeOM","indicator":"NewCustomer_indicator__2AE_R","color":"NewCustomer_color__1aS3W"};